import { Box, Button, Divider } from '@mui/material';
import FileListFillIcon from 'remixicon-react/FileListFillIcon';
import QuestionFillIcon from 'remixicon-react/QuestionFillIcon';
import ChatQuoteFillIcon from 'remixicon-react/ChatQuoteFillIcon';
import { theme } from 'config/theme';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import AddPostModal from 'components/modals/addPostModal/AddPostModal';
import { useState } from 'react';
import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { useBuildWiseModules } from '@buildwise/libs/helpers';

function PostButtons() {
  const { state } = useLocation();
  const [openAddArticleModal, setOpenAddArticleModal] = useState<ArticleSourceType | undefined>(
    !!state?.articleFormState ? ArticleSourceType.POST : undefined,
  );
  const { isLoadingBuildWiseModules, homeModuleFeatures } = useBuildWiseModules();

  if (isLoadingBuildWiseModules) {
    return null;
  }

  return (
    <Container
      justifyContent={
        homeModuleFeatures['Ask Peers'].isActive &&
        homeModuleFeatures['Suggest Improvements'].isActive
          ? 'space-between'
          : 'flex-start'
      }
    >
      <Button
        startIcon={<FileListFillIcon size={20} color={theme.palette.custom.pirateGold} />}
        onClick={() => setOpenAddArticleModal(ArticleSourceType.POST)}
        variant="contained"
        sx={(theme) => ({
          borderRadius: '8px',
          padding: 3,
          color: theme.palette.custom.dusk,
          fontSize: 15,
          fontWeight: 700,
          backgroundColor: theme.palette.custom.yellowBorder,
          '&:hover': {
            backgroundColor: theme.palette.custom.yellowBorder,
          },
        })}
      >
        {homeModuleFeatures['Share Knowledge'].displayName}
      </Button>
      {homeModuleFeatures['Ask Peers'].isActive && (
        <>
          <Divider orientation="vertical" flexItem />
          <Button
            startIcon={<QuestionFillIcon size={20} color={theme.palette.custom.dodgerBlue} />}
            onClick={() => setOpenAddArticleModal(ArticleSourceType.QUESTION)}
            variant="contained"
            sx={{
              borderRadius: '8px',
              padding: 3,
              color: theme.palette.custom.dusk,
              border: 'none',
              fontSize: 15,
              fontWeight: 700,
              backgroundColor: '#c7ecff',
              '&:hover': {
                border: 'none',
                backgroundColor: '#c7ecff',
              },
            }}
          >
            {homeModuleFeatures['Ask Peers'].displayName}
          </Button>
        </>
      )}

      {homeModuleFeatures['Suggest Improvements'].isActive && (
        <>
          <Divider orientation="vertical" flexItem />
          <Button
            startIcon={<ChatQuoteFillIcon size={20} color={theme.palette.custom.cloverGreen} />}
            onClick={() => setOpenAddArticleModal(ArticleSourceType.SUGGESTION)}
            variant="contained"
            sx={{
              borderRadius: '8px',
              padding: 3,
              color: theme.palette.custom.dusk,
              fontSize: 15,
              fontWeight: 700,
              border: 'none',
              backgroundColor: '#d2ffde',
              '&:hover': {
                border: 'none',
                backgroundColor: '#d2ffde',
              },
            }}
          >
            {homeModuleFeatures['Suggest Improvements'].displayName}
          </Button>
        </>
      )}

      {openAddArticleModal && (
        <AddPostModal
          articleType={openAddArticleModal}
          open={!!openAddArticleModal}
          setOpen={() => setOpenAddArticleModal(undefined)}
          selectedFeedFilters={[]}
          articleFormState={state?.articleFormState}
        />
      )}
    </Container>
  );
}

const Container = styled(Box)({
  borderRadius: 12,
  padding: '8px 0',
  display: 'flex',
  alignItems: 'center',
  gap: 32,
});

export default PostButtons;
